import { Module } from 'vuex'
import actions from '@/modules/common/store/entityActions'
import mutations from '@/modules/common/store/entityMutations'
import getters from '@/modules/common/store/entityGetters'
import RootState from '@/store/rootState'
import EntityState from '@/modules/common/store/entityState'
import EntityService from '@/modules/common/services/entityService'
import timesheetResource from '@/modules/timesheet/services/timesheetResource'
import Timesheet from '@/modules/timesheet/domain/timesheet'

const contactModule: Module<EntityState<Timesheet>, RootState> = {
  namespaced: true,
  state: new EntityState(),
  mutations,
  getters,
  actions: actions(new EntityService(timesheetResource, Timesheet), 'timesheet')
}

export default contactModule
